// extracted by mini-css-extract-plugin
export default {"buttons":"AuthButtons_buttons__M2gc8"};